(function () {
    function initDyuProductLayout(scope) {
        scope.querySelectorAll('.dyu-eu-m20-us-layout .productView-images img').forEach(function (image) {
            if (image.dataset.dyuImageBound) return;
            image.dataset.dyuImageBound = 'true';
            var holder = image.closest('.productView-img-container, .productView-thumbnail-link');
            if (!holder) return;
            function loaded() { holder.classList.remove('dyu-image-failed'); }
            function failed() {
                // Retry the same media at a bounded size, never substitute another product image.
                var fallback = image.getAttribute('data-dyu-image-fallback');
                if (fallback && !image.dataset.dyuFallbackAttempted) {
                    image.dataset.dyuFallbackAttempted = 'true';
                    loaded();
                    image.removeAttribute('srcset');
                    image.src = fallback;
                    return;
                }
                holder.classList.add('dyu-image-failed');
            }
            image.addEventListener('load', loaded);
            image.addEventListener('error', failed);
            if (image.complete && image.currentSrc) {
                if (image.naturalWidth > 0) loaded();
                else failed();
            }
        });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initDyuProductLayout(document); });
    } else { initDyuProductLayout(document); }
    document.addEventListener('shopify:section:load', function (event) {
        initDyuProductLayout(event.target);
    });
})();
